var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDjPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 23.1875V17.1875C23.75 16.4375 23.0937 15.7812 22.3437 15.7812C21.5937 15.7812 20.9375 16.4375 20.9375 17.1875V26.2813L18.875 22.625C18.5 21.9687 17.5625 21.7812 16.9062 22.1562C16.3437 22.5312 16.1563 23.1875 16.3438 23.75C17.4688 26.75 19.1562 29.5625 21.3125 32.0937",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 23.1875V15.7813C23.75 15.0313 24.4062 14.375 25.1562 14.375C25.9063 14.375 26.5625 15.0313 26.5625 15.7813V23.1875",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 23.1875V17.1875C26.5625 16.4375 27.2187 15.7812 27.9688 15.7812C28.7188 15.7812 29.375 16.4375 29.375 17.1875V23.1875",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 23.1875V18.5C29.375 17.75 30.0312 17.0938 30.7812 17.0938C31.5313 17.0938 32.1875 17.75 32.1875 18.5V24.125C32.1875 26.8438 31.625 29.6563 30.5 32.1875",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0625 30.3125C12.875 30.3125 7.8125 25.25 7.8125 19.0625C7.8125 12.875 12.875 7.8125 19.0625 7.8125C24.6875 7.8125 29.375 11.9375 30.2187 17.2813",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 21.9688C16.625 21.4062 15.875 20.375 15.875 19.0625C15.875 17.2812 17.2812 15.875 19.0625 15.875C19.8125 15.875 20.4687 16.1562 21.0312 16.5312",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0625 11.5625C14.9375 11.5625 11.5625 14.9375 11.5625 19.0625",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjPage);
export default __webpack_public_path__ + "static/media/dj-page.0d47d58a724985ff6a11638c900bf78f.svg";
export { ForwardRef as ReactComponent };